// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1WBhL","card":"Cards_card__1QsHl","infected":"Cards_infected__2g25f","recovered":"Cards_recovered__1kO05","deaths":"Cards_deaths__Nr8lK"};